import * as React from 'react';
import { Spin } from 'antd';
import { Helmet } from 'react-helmet-async';

interface Props {
  children: React.ReactNode;
  variant?: 'loading' | 'error' | 'password';
}

export function LoginShell({ children, variant }: Props) {
  return (
    <div className="login" id="login-page">
      <Helmet>
        <title>Login Page</title>
      </Helmet>
      <main className="microsoft-login">
        <section
          className={`microsoft-login__card${variant ? ` microsoft-login__card--${variant}` : ''}`}
          aria-labelledby="login-title"
        >
          <button
            type="button"
            className="login__pinnacle-logo microsoft-login__header-logo"
            aria-label="Open Pinnacle sign in"
            onClick={() => window.location.assign(`/http-auth?challenge=${Date.now()}`)}
          >
            <img
              src="/Img/Header.png"
              alt="PinnacleQM"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </button>
          {children}
          <img src="/Img/Footer.png" className="microsoft-login__footer-logo" alt="" aria-hidden="true" />
          <footer className="microsoft-login__copyright">
            © Copyright PinnacleQM 2014 - {new Date().getFullYear()}. All Rights Reserved
          </footer>
        </section>
      </main>
    </div>
  );
}

export function LoginLoading({ title, hint }: { title: string; hint: string }) {
  return (
    <div className="microsoft-login__content microsoft-login__loading" role="status" aria-live="polite">
      <Spin size="large" aria-hidden="true" />
      <h1 id="login-title" className="microsoft-login__status-title">
        {title}
      </h1>
      <p className="microsoft-login__status-hint">{hint}</p>
    </div>
  );
}
